/**
 * Blog publish injects route aliases (and post clones) that reuse the same page id.
 * Navigation by id must resolve to a single canonical page, not every clone.
 *
 * @see apps/Services/BlogService.php search_terms / post clones
 */
export const BLOG_ROUTE_ALIASES = [
  'c',
  's',
  'a',
  'page',
  'blog-login',
  'feed-news',
  'author',
  't',
];

/**
 * @param {string|number} pageId
 * @param {Array} [pages]
 * @returns {object|null}
 */
export function resolvePageById(pageId, pages) {
  if (pageId === null || typeof pageId === 'undefined' || pageId === '') {
    return null;
  }

  const list = pages || (typeof pagesConfig !== 'undefined' ? pagesConfig : null);
  if (!list || !list.length) {
    return null;
  }

  const matches = list.filter((page) => page && page.id == pageId);
  if (!matches.length) {
    return null;
  }
  if (matches.length === 1) {
    return matches[0];
  }

  const isAlias = (page) =>
    BLOG_ROUTE_ALIASES.includes(String(page.url || '').toLowerCase());

  const hasPostId = (page) =>
    typeof page.post_id !== 'undefined' && page.post_id !== null && page.post_id !== '';

  const canonical = matches.find((page) => !hasPostId(page) && !isAlias(page));
  if (canonical) {
    return canonical;
  }

  const withoutPost = matches.find((page) => !hasPostId(page));
  if (withoutPost) {
    return withoutPost;
  }

  return matches[0];
}
